import * as actionTypes from "./actionTypes";
import { getAxiosInstance } from "../../../np-rest/rest";
import { snackActions } from '../../../sc-utilities/SnackBar';

const loginStart = () => {
    return {
        type: actionTypes.CORE_LOGIN_START
    };
};

export const loginSuccess = (response) => {
    return {
        type: actionTypes.CORE_LOGIN_SUCCESS,
        token: response.Token,
        permissions: response.permissions ? response.permissions : [],
        customers: response.customers ? response.customers : [],
        activeCustomer: response.activeCustomer ? response.activeCustomer : {},
        user: response,
        expiresAt: response.expiresAt,
        activeExternalServiceAvailable: response.activeExternalServiceAvailable,
        userSettings: response.UserSettings,
        passwordComplexity: response.PasswordComplexity,
        passwordExpired: response.PasswordExpires
    };
};

export const loginFail = error => {
    return {
        type: actionTypes.CORE_LOGIN_FAIL,
        error: error
    };
};

export const setDefaultLanguage = userSettings => {
    return {
        type: actionTypes.SET_DEFAULT_TRANSLATION,
        DefaultLanguage: userSettings.DefaultLanguage
    };
};

export const login = loginData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(loginStart());
        try {
            let res = await rest.post("/users/login", loginData);
            if (res.data && res.data.succeeded) {
                if (res?.data?.result?.data?.PasswordExpires) {
                    localStorage.setItem('CORE|AUTH|PASSWORD|EXPIRED', true);
                }
                return res.data.result.data;
            } else {
                if (res?.data?.error?.result?.clearCache) {
                    window.location.reload();

                }
                if (res.data.status === 401) {
                    dispatch(loginFail(res.data.message));
                    snackActions.snackBar({
                        message: res.data.message || "Invalid username or password. Please try to login again.",
                        options: {
                            variant: "error"
                        }
                    })
                    return null;
                } else {
                    dispatch(loginFail(res.data.message));
                    snackActions.snackBar({
                        message: res.data.message,
                        options: {
                            variant: "error"
                        }
                    })

                }
                return null;
            }
        } catch (error) {
            dispatch(loginFail(error));
            snackActions.snackBar({
                message: error.message,
                options: {
                    variant: "error"
                }
            })
        }
        return null;
    };
};

/**
 * LOGOUT SECTION
 */
export const logoutStart = () => {
    return {
        type: actionTypes.CORE_LOGOUT_START
    };
};

export const logoutSuccess = () => {
    return {
        type: actionTypes.CORE_LOGOUT_SUCCESS
    };
};

export const logoutFailed = error => {
    return {
        type: actionTypes.CORE_LOGOUT_FAIL,
        error: error
    };
};

export const logout = activeCustomerID => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(logoutStart());
        try {
            let res = await rest.post("/users/logout", { ActiveCustomerID: activeCustomerID });
            if (res.data && res.data.succeeded) {
                dispatch(logoutSuccess());
            } else {
                dispatch(logoutSuccess());
            }
        } catch (error) {
            dispatch(logoutSuccess());
        }
    };
};

export const sessionExtended = error => {
    return {
        type: actionTypes.USER_SESSION_EXTENDED,
    };
};

export const sessionExpired = error => {
    return {
        type: actionTypes.USER_SESSION_EXPIRED,
    };
};

export const extendSession = loginData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post("/users/extend-session-timeout", loginData);
            if (res.data.status === 200) {
                dispatch(sessionExtended());
                snackActions.snackBar({
                    message: res.data.message || "Session extended.",
                    options: {
                        variant: "success"
                    }
                })

            }
            if (res.data.status === 400) {
                snackActions.snackBar({
                    message: res.data.message || "Session not extended.",
                    options: {
                        variant: "error"
                    }
                })

            }
        } catch (error) {
            snackActions.snackBar({
                message: error.message,
                options: {
                    variant: "error"
                }
            })
        }
    };
};

const saveColumnsFilterStart = () => {
    return {
        type: actionTypes.CORE_AUTH_SAVE_FILTER_START
    };
};

const saveColumnsFilterSuccess = (result) => {
    return {
        type: actionTypes.CORE_AUTH_SAVE_FILTER_SUCCESS,
        columns: result
    };
};

const saveColumnsFilterFail = error => {
    return {
        type: actionTypes.CORE_AUTH_SAVE_FILTER_FAIL,
        error: error
    };
};

export const saveColumnsFilter = data => {
    let activeCustomerID = data.ActiveCustomerID
    delete data['ActiveCustomerID']
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(saveColumnsFilterStart());
        try {
            let res = await rest.post("/users/update-settings", {
                type: "TableState",
                Columns: { ...data },
                ActiveCustomerID: activeCustomerID
            });
            if (res.data.succeeded) {
                if (res.data.succeeded) {
                    dispatch(saveColumnsFilterSuccess(data));
                    snackActions.snackBar({
                        message: `${res.data.message}`,
                        options: {
                            variant: "success"
                        }
                    })
                } else {
                    dispatch(saveColumnsFilterFail(res.error));
                    snackActions.snackBar({
                        message: `${res.data.message}`,
                        options: {
                            variant: "error"
                        }
                    })
                }
            } else {
                dispatch(saveColumnsFilterFail(res.error));
            }
        } catch (err) {
            dispatch(saveColumnsFilterFail(err));
            snackActions({
                message: `${err}`,
                options: {
                    variant: "error"
                }
            })
        }
    };
};

export const forgotPassword = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/users/forgot-password', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: "Email for password change sent.",
                    options: {
                        variant: "success"
                    }
                })
                return res;
            } else {
                if (res.data.status === 401) {
                    snackActions.snackBar({
                        message: res.data.message || "User with given email not found.",
                        options: {
                            variant: "error"
                        }
                    })
                    return res;
                } else {
                    snackActions.snackBar({
                        message: res.data.message,
                        options: {
                            variant: "error"
                        }
                    })
                    return res;
                }
            }
        } catch (error) {
            snackActions.snackBar({
                message: error.message,
                options: {
                    variant: "error"
                }
            })
        }
    };
}

export const openIDConnect = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/openid/start', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: "Started OpenID Connect flow.",
                    options: {
                        variant: "success"
                    }
                })
                return res;
            } else {

                snackActions.snackBar({
                    message: res.data.message,
                    options: {
                        variant: "error"
                    }
                })
                return res;

            }
        } catch (error) {
            snackActions.snackBar({
                message: error.message,
                options: {
                    variant: "error"
                }
            })
        }
    };
};

export const createOpenIDUser = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/openid/create-user', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: "Successfully created OpenID user.",
                    options: {
                        variant: "success"
                    }
                })
                if (res.data.result.data && res.status === 200) {
                    return res;
                }
            } else {
                snackActions.snackBar({
                    message: res.data.message,
                    options: {
                        variant: "error"
                    }
                })
                return false;

            }
        } catch (error) {
            snackActions.snackBar({
                message: error.message,
                options: {
                    variant: "error"
                }
            })
        }
    };
};


export const getLoginData = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/openid/get-login-data', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: "Started OpenID Connect flow.",
                    options: {
                        variant: "success"
                    }
                })
                return res.data.result.data;
            } else {

                snackActions.snackBar({
                    message: res.data.message,
                    options: {
                        variant: "error"
                    }
                })
                return res;

            }
        } catch (error) {
            snackActions.snackBar({
                message: error.message,
                options: {
                    variant: "error"
                }
            })
        }
    };
};

export const openIDLogin = (params) => {
    return async dispatch => {
        try {

            dispatch(loginSuccess(params));
            return true;
        } catch (error) {
            snackActions.snackBar({
                message: "Internal server error.",
                options: {
                    variant: "error"
                }
            })
        }
    };
}


